
/**
 * DeletePatrimonioChecklistMaquinaEquipUseCase
 */

import { IDeletePatrimonioChecklistMaquinaEquipUseCase } from "../../../presentation/useCases/delete/delete_patrimonio_checklist_maquina_equip_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

export class DeletePatrimonioChecklistMaquinaEquipUseCase implements IDeletePatrimonioChecklistMaquinaEquipUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async deletePatrimonioChecklistMaquinaEquip(idPatrimonioChecklistMaquinaEquip: number): Promise<void> {
    await this.repository.deletePatrimonioChecklistMaquinaEquip(idPatrimonioChecklistMaquinaEquip);
  }
}
